"use client";
import InpSafeForm from "@/components/atoms/FormComponents/InpSafeForm";
import { onInpSafeButtonClick } from "@/helpers/inpSafeForm";

import { Controller } from "react-hook-form";
import styles from "./NsatRegistrationForm.module.scss";
import { useNsatRegistrationFormController } from "./controller/useNsatRegistrationFormController";
import type { NsatRegistrationFormProps } from "./model/nsatRegistrationForm.types";

// const TIME_SLOTS = [
//   "9:00 AM to 10:00 AM",
//   "10:00 AM to 11:00 AM",
//   "11:00 AM to 12:00 PM",
//   "12:00 PM to 01:00 PM",
//   "01:00 PM to 02:00 PM",
//   "02:00 PM to 03:00 PM",
//   "03:00 PM to 04:00 PM",
//   "04:00 PM to 05:00 PM",
//   "05:00 PM to 06:00 PM",
// ];

const ChevronDown = () => (
  <svg
    className={styles.chevron}
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export default function NsatRegistrationForm(
  props: NsatRegistrationFormProps,
) {
  const {
    control,
    errors,
    isSubmitting,
    isOTPLoading,
    isFormDisabed,
    programs,
    degreeOptions,
    countryCodes,
    SELECT_DEGREE,
    SELECT_PROGRAM,
    submitBtnText,
    ctaText,
    handleFieldChange,
    handlePhoneNumberChange,
    handleFieldBlur,
    handleFullNameFocus,
    handleFormSubmit,
  } = useNsatRegistrationFormController(props);

  const isLoading = isSubmitting;

  return (
    <>
      <InpSafeForm
        className={styles.form}
        onSubmit={handleFormSubmit}
        noValidate
      >
        <Controller
          name="fullName"
          control={control}
          render={({ field }) => (
            <input
              className={styles.input}
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={field.value ?? ""}
              onChange={(e) => handleFieldChange("fullName", e.target.value)}
              onFocus={handleFullNameFocus}
              onBlur={() => {
                field.onBlur();
                handleFieldBlur("fullName");
              }}
              disabled={isLoading || isOTPLoading || isFormDisabed}
            />
          )}
        />
        {errors.fullName && (
          <p className={styles.error}>{errors.fullName}</p>
        )}

        <Controller
          name="emailId"
          control={control}
          render={({ field }) => (
            <input
              className={styles.input}
              type="email"
              name="emailId"
              placeholder="Email Address"
              value={field.value ?? ""}
              onChange={(e) => handleFieldChange("emailId", e.target.value)}
              onFocus={handleFullNameFocus}
              onBlur={() => {
                field.onBlur();
                handleFieldBlur("emailId");
              }}
              disabled={isLoading || isOTPLoading || isFormDisabed}
            />
          )}
        />
        {errors.emailId && (
          <p className={styles.error}>{errors.emailId}</p>
        )}

        <div className={styles.phoneRow}>
          <div className={styles.selectWrap}>
            <Controller
              name="countryCode"
              control={control}
              render={({ field }) => (
                <select
                  className={`${styles.countryCode} lining-nums`}
                  name="countryCode"
                  value={field.value ?? ""}
                  onChange={(e) =>
                    handleFieldChange("countryCode", e.target.value)
                  }
                  disabled={true}
                >
                  {countryCodes.map((code) => (
                    <option key={code} value={code}>
                      {code}
                    </option>
                  ))}
                </select>
              )}
            />
            <ChevronDown />
          </div>
          <Controller
            name="phoneNumber"
            control={control}
            render={({ field }) => (
              <input
                className={`${styles.mobileInput} lining-nums`}
                type="tel"
                name="phoneNumber"
                placeholder="Mobile No."
                value={field.value ?? ""}
                onChange={(e) => handlePhoneNumberChange(e.target.value)}
                onFocus={handleFullNameFocus}
                onBlur={() => {
                  field.onBlur();
                  handleFieldBlur("phoneNumber");
                }}
                disabled={isLoading || isOTPLoading || isFormDisabed}
              />
            )}
          />
        </div>
        {(errors.countryCode || errors.phoneNumber) && (
          <p className={styles.error}>
            {errors.countryCode || errors.phoneNumber}
          </p>
        )}

        <div>
          <div className={styles.selectWrap}>
            <Controller
              name="degree"
              control={control}
              render={({ field }) => (
                <select
                  className={styles.select}
                  name="degree"
                  value={field.value ?? ""}
                  onChange={(e) => handleFieldChange("degree", e.target.value)}
                  onFocus={handleFullNameFocus}
                  onBlur={() => {
                    field.onBlur();
                    handleFieldBlur("degree");
                  }}
                  disabled={isLoading || isOTPLoading || isFormDisabed}
                >
                  <option value={SELECT_DEGREE} disabled>
                    {SELECT_DEGREE}
                  </option>
                  {degreeOptions.map((p) => (
                    <option key={p} value={p}>
                      {p}
                    </option>
                  ))}
                </select>
              )}
            />
            <ChevronDown />
          </div>
          {errors.degree && (
            <p className={styles.error}>{errors.degree}</p>
          )}
        </div>

        <div>
          <div className={styles.selectWrap}>
            <Controller
              name="program"
              control={control}
              render={({ field }) => (
                <select
                  className={styles.select}
                  name="program"
                  value={field.value ?? ""}
                  onChange={(e) => handleFieldChange("program", e.target.value)}
                  onFocus={handleFullNameFocus}
                  onBlur={() => {
                    field.onBlur();
                    handleFieldBlur("program");
                  }}
                  disabled={isLoading || isOTPLoading || isFormDisabed}
                >
                  <option value={SELECT_PROGRAM} disabled>
                    Select Program
                  </option>
                  {programs.map((p) => (
                    <option key={p} value={p}>
                      {p}
                    </option>
                  ))}
                </select>
              )}
            />
            <ChevronDown />
          </div>
          {errors.program && (
            <p className={styles.error}>{errors.program}</p>
          )}
        </div>

        {/* <div>
          <div className={styles.selectWrap}>
            <select
              className={`${styles.select} lining-nums`}
              name="slot"
              value={formValues.slot}
              onChange={(e) => handleFieldChange("slot", e.target.value)}
              onFocus={handleFullNameFocus}
              disabled={isLoading || isOTPLoading || isFormDisabed}
            >
              <option value={SELECT_SLOT} disabled>
                Pick a Time Slot
              </option>
              {TIME_SLOTS.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
            <ChevronDown />
          </div>
          {errors.slot && (
            <p className={styles.error}>{errors.slot}</p>
          )}
        </div> */}

        <button
          className={styles.submitBtn}
          type="button"
          onClick={onInpSafeButtonClick}
          disabled={isLoading || isOTPLoading}
        >
          <span className={styles.desktopText}>
            {submitBtnText || ctaText}
          </span>
          <span className={styles.mobileText}>
            {submitBtnText || ctaText}
          </span>
          {/* <span className={styles.mobileText}>REGISTER FOR FREE</span> */}
        </button>

        <p className={styles.formDisclaimer}>
          By entering these details I agree that Amity University Online and its
          associates can contact me with updates & notifications via Email, SMS,
          WhatsApp, and Voice call as per its{" "}
          <a
            href="https://amityonline.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "underline",
              textDecorationColor: "inherit",
              cursor: "pointer",
            }}
          >
            Privacy Policy
          </a>
          . This consent will override any registration for DNC / NDNC.
        </p>
      </InpSafeForm>
    </>
  );
}
